import { css } from '@bts-web/utils-style-engine';
import { DocumentationExternalLink } from '../../../../../../common';
import { TradeOfferDataNonNullable } from '../../../../types';
import { URL_RISK_WARNING } from '@bts-web/core-app-config';
import { useClientLocale } from '@bts-web/utils-lokalise';

export interface AcceptOfferNonComplexProductsTermsTranslations {
  costTransparencyTitle: string;
  kidTitle: string;
  kidDisclaimerPartOne: string;
  kidDisclaimerPartTwo: string;
  riskWarningText1: string;
  riskWarningText2: string;
}

interface AcceptOfferNonComplexProductsTermsProps {
  translations: AcceptOfferNonComplexProductsTermsTranslations;
  legalDocumentUrl: string;
  warnings: TradeOfferDataNonNullable['warnings'];
  kid?: string;
}

const primaryTextStyles = css({
  color: 'neutrals.text_primary',
  fontSize: 'caption.medium_medium',
  fontWeight: 500,
  letterSpacing: 'caption.medium_medium',
  lineHeight: 'caption.medium_medium',
});

const secondaryTextStyles = css({
  display: 'inline',
  color: 'neutrals.text_secondary',
  fontSize: 'caption.medium_medium',
  fontWeight: 'caption.medium_medium',
  letterSpacing: 'caption.medium_medium',
  lineHeight: 'caption.medium_medium',
});

const spaceChar = ' ';

const AcceptOfferNonComplexProductsTerms = ({
  translations,
  legalDocumentUrl,
  warnings,
  kid,
}: AcceptOfferNonComplexProductsTermsProps) => {
  const locale = useClientLocale();

  const executionOnlyConsent = warnings?.find(
    (warning) => warning.messageKey === 'execution_only_consent',
  );

  let executionOnlyConsentParagraphs;

  if (executionOnlyConsent?.message) {
    executionOnlyConsentParagraphs = executionOnlyConsent.message.split('\n\n');
  }

  return (
    <div
      className={css({
        display: 'flex',
        flexDirection: 'column',
        gap: 'medium',
        alignItems: 'start',
        alignSelf: 'flex-start',
        textAlign: 'left',
      })}
      data-testid="buy-terms-non-complex"
    >
      <DocumentationExternalLink
        size="small"
        visual="primaryUnderline"
        href={legalDocumentUrl}
        label={translations.costTransparencyTitle}
      />

      {kid && (
        <p className={secondaryTextStyles}>
          {spaceChar}
          <DocumentationExternalLink
            size="small"
            visual="primaryUnderline"
            href={kid}
            label={translations.kidTitle}
          />
          {spaceChar}
        </p>
      )}

      {executionOnlyConsentParagraphs && (
        <div
          className={css({
            display: 'flex',
            flexDirection: 'column',
            gap: 'extra_small_3',
          })}
        >
          <p className={primaryTextStyles}>
            {executionOnlyConsentParagraphs[0]}
          </p>
          <p className={secondaryTextStyles}>
            {translations.riskWarningText1}
            {spaceChar}
            <DocumentationExternalLink
              className={secondaryTextStyles}
              size="small"
              visual="captionUnderline"
              href={URL_RISK_WARNING[locale] || URL_RISK_WARNING['en']}
              label={translations.riskWarningText2}
            />
          </p>
        </div>
      )}
    </div>
  );
};

export { AcceptOfferNonComplexProductsTerms };
